<template>
  <CancelFlowRedesignExperiment>
    <template #default>
      <ChangePlanOriginal/>
    </template>
    <template #redesign>
      <ChangePlanRedesign/>
    </template>
  </CancelFlowRedesignExperiment>
</template>

<script setup>
import CancelFlowRedesignExperiment from '@/components/account/membership/new/CancelFlowRedesignExperiment.vue'
import ChangePlanOriginal from '@/components/account/membership/ChangePlan.vue'
import ChangePlanRedesign from '@/views/account/ChangePlan.vue'
</script>
